import { render, staticRenderFns } from "./ngo-upload-page.vue?vue&type=template&id=7ef77961&scoped=true&"
import script from "./ngo-upload-page.vue?vue&type=script&lang=js&"
export * from "./ngo-upload-page.vue?vue&type=script&lang=js&"
import style0 from "./ngo-upload-page.vue?vue&type=style&index=0&id=7ef77961&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef77961",
  null
  
)

export default component.exports